exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selected-badge[data-v-1628270f] {\n    position: absolute;\n    z-index: 9;\n    transform: rotate(-40deg);\n    left: -3px;\n    font-size: 1.2rem;\n}\n", ""]);

// exports
